import React from 'react';

export default class Page4 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt ">
                                    <div className="innerpadding">
                                        <div className="ilead-contentarea">
                                            <div className="circle_title-first"><span
                                                className="heading"><img
                                                src={require('@images/greendot.jpg')}
                                                className="heading_image"/></span><span className="heading">
                   TOOLS TO AID DECISION MAKING
                   </span></div>
                                            <p>Now you’re aware of the possible influences on your decision
                                                making ability, we’ll suggest three
                                                techniques to help counteract some of them – one for when
                                                you’re on your own, and two for
                                                group situations.</p>

                                            <div className="border_subtitle">Mind Mapping<a
                                                className="superscripttext superBold"
                                                href="further_info.php?course=300"><sup>7</sup></a></div>
                                            <p>This allows you to use your imagination and logic
                                                simultaneously, stimulating more of your brain
                                                than you might otherwise use at any one time. It helps you
                                                consider and evaluate more information
                                                relevant to an issue and, therefore, enables a quicker and
                                                more effective decision. All you
                                                need are some large sheets of paper, several coloured pens
                                                and the willingness to try
                                                something different!</p>
                                            <p>Start by drawing or writing whatever it is you need to make a
                                                decision about in the middle of your
                                                sheet of paper. For example, if you’re trying to decide
                                                whether to launch a new brand, write ‘New
                                                Brand.’ Then, let your thoughts about it flow. For each
                                                different or ‘key’ thought, draw a line or
                                                squiggle radiating from the central symbol and write, or
                                                draw, the thought along it.</p>
                                            <p>You can use different colours for different branches, or to
                                                indicate that they relate to each other.
                                                Some or all of the branches might then sprout others, like
                                                this:</p>
                                            <div className="innovativeimg">
                                                <img
                                                    src={require('@images/mind_mapping.png')}
                                                    style={{width:'100%'}}/>
                                            </div>

                                            <p>When you feel you’ve finished your ‘mind map’ you’ll have a
                                                picture of all the important and lesser
                                                elements relating to the decision. It’ll help you see how
                                                ideas and actions link up to become
                                                meaningful output. You could use it for discussion with
                                                others – ask them for comments or to
                                                make their own to compare with it, before making a
                                                decision.</p>
                                            <div className="border_subtitle">Brainstorming</div>
                                            <p>This is used in groups to flush out as many ideas as possible
                                                before making a decision – a
                                                favourite way is to gather people in a room with a flipchart
                                                and to ask them to start throwing out
                                                ideas on a given topic, such as: ‘Why should we outsource
                                                our call centre to India?’
                                            </p>
                                            <p>No one should be allowed to express judgements until the
                                                brainstorming process is completed.
                                                Building on each other’s ideas is encouraged and all
                                                suggestions – even wild ones – should
                                                be recorded.</p>
                                            <p>However, even during brainstorming some of the biases we
                                                described earlier, like conformity or
                                                groupthink, can surface to inhibit the process, unless very
                                                effectively managed. One way to avoid
                                                this is to brainstorm electronically, which can yield even
                                                better results.</p>
                                            <p>In electronic brainstorming, all contributors type their
                                                contributions into a laptop, and they then
                                                flash up on a large screen which everyone can see. This
                                                means that the contributions are kept
                                                anonymous and contributors can build on others’ ideas.</p>


                                            <div className="left-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page3')}
                                                    className="button-next-previous-done thought">&lt;&lt; Previous
                                                </div>
                                            </div>
                                            <div className="right-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page5')}
                                                    className="button-next-previous-done thought">Next &gt;&gt;</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>

                    </div>
                </div>
            </div>
        </div>;
    }
}